<template><div><h1 id="kosten-ereignis-ereignispositionen" tabindex="-1"><a class="header-anchor" href="#kosten-ereignis-ereignispositionen"><span>Kosten Ereignis/Ereignispositionen</span></a></h1>
<p>Ereigniskosten — Anzeige der Ereigniskosten</p>
<h2 id="beschreibung" tabindex="-1"><a class="header-anchor" href="#beschreibung"><span>Beschreibung</span></a></h2>
<p>Die Ereigniskosten werden sowohl zu einem Ereignis, wie auch zu einer Ereignisposition angezeigt. Die Kostenansicht auf Stufe Ereignis beinhaltet im Total immer auch die aufsummierten Beträge aus den Ereignis-Positionen.</p>
<p>Pfad: <code v-pre>Personen → Ereignisse</code></p>
<h2 id="datenfelder-kosten" tabindex="-1"><a class="header-anchor" href="#datenfelder-kosten"><span>Datenfelder Kosten</span></a></h2>
<dl>
<dt>Struktur</dt>
<dd>Strukturposition aus der Tabelle<a class="link" href="ft.refdata.tblereigniskostenstruktur.html" title="Ereigniskostenstruktur">Ereigniskostenstruktur</a>.</dd>
<dt>Konto/Kostenstelle/Kostenträger</dt>
<dd>Verbuchungsinfo zur Rechnung</dd>
<dt>Betrag</dt>
<dd>Kostenbetrag</dd>
<dt>Beleg-Nr</dt>
<dd>Kostenbetrag</dd>
</dl>
<h2 id="datenfelder-detail" tabindex="-1"><a class="header-anchor" href="#datenfelder-detail"><span>Datenfelder Detail</span></a></h2>
<dl>
<dt>Datum</dt>
<dd>Datum des Kosteneintrages (relevant für Statistiken mit Datumsbereich)</dd>
<dt>Betrag</dt>
<dd>Kostenbetrag</dd>
<dt>Beleg-Nr</dt>
<dd>Nummer der Rechnung</dd>
<dt>Lieferant</dt>
<dd>Lieferantenname (Rechnungssteller)</dd>
<dt>Bemerkung</dt>
<dd>Bemerkungsfeld.</dd>
</dl>
<h2 id="funktionen" tabindex="-1"><a class="header-anchor" href="#funktionen"><span>Funktionen</span></a></h2>
<p>Standardfunktionalität</p>
<h2 id="siehe-auch" tabindex="-1"><a class="header-anchor" href="#siehe-auch"><span>Siehe auch</span></a></h2>
<p><RouteLink to="/referenz/refs/ft.refdata.ereigkosten.html" title="Kosten Ereignis/Ereignispositionen">Ereigniskosten</RouteLink>, <RouteLink to="/referenz/refs/ft.refdata.tblereigniskostenstruktur.html" title="Ereigniskostenstruktur">Ereigniskostenstruktur</RouteLink></p>
</div></template>


